import React from 'react';
import {
  Box,
  Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemButton,
  ListItemIcon, ListItemSecondaryAction, ListItemText, Menu, MenuItem,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowDown, faArrowUp, faTimes, faTrash,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

function GroupEditor({
  ctxMenuopened, ctxMenu, onCloseCtxMenu,
  onDeleteItem, onEditItem,
  editDialog, onCloseEditDialog, subItems,
  onRemoveSubGroup, onUpSubgroup, onDownSubgroup,
}) {
  return (
    <>
      <Menu
        open={ctxMenuopened}
        anchorReference="anchorPosition"
        anchorPosition={
          ctxMenuopened
            ? { top: ctxMenu.y, left: ctxMenu.x }
            : null
        }
        onClose={onCloseCtxMenu}
      >
        <MenuItem
          onClick={() => {
            onEditItem(ctxMenu.node.dataset.name);
            onCloseCtxMenu();
          }}
        >
          <ListItemIcon>
            <FontAwesomeIcon icon={faEdit} />
          </ListItemIcon>
          <ListItemText>Редагувати</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onDeleteItem(ctxMenu.node.dataset.name);
            onCloseCtxMenu();
          }}
          sx={{ color: 'warning.main' }}
        >
          <ListItemIcon sx={{ color: 'warning.main' }}>
            <FontAwesomeIcon icon={faTrash} />
          </ListItemIcon>
          <ListItemText>Видалити</ListItemText>
        </MenuItem>
      </Menu>
      <Dialog open={editDialog.opened} onClose={onCloseEditDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Редагування группування</DialogTitle>
        <DialogContent>
          <Box sx={{
            // width: '100%',
            bgcolor: 'background.paper',
            border: 1,
            borderRadius: 2,
            borderColor: 'grey.500',
          }}
          >
            <List sx={{ width: 1 }}>
              {subItems.map((item, i) => (
                <ListItem disablePadding key={item.name}>
                  <ListItemButton>
                    <ListItemText primary={item.label} />
                    <ListItemSecondaryAction>
                      <IconButton disabled={i === 0} onClick={() => onUpSubgroup(i)}>
                        <FontAwesomeIcon icon={faArrowUp} size="xs" />
                      </IconButton>
                      <IconButton
                        disabled={i === subItems.length - 1}
                        onClick={() => onDownSubgroup(i)}
                      >
                        <FontAwesomeIcon icon={faArrowDown} size="xs" />
                      </IconButton>
                      <IconButton
                        color="warning"
                        onClick={() => onRemoveSubGroup(item.name)}
                        disabled={subItems.length === 1}
                      >
                        <FontAwesomeIcon icon={faTimes} size="xs" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

GroupEditor.propTypes = {
  ctxMenuopened: PropTypes.bool.isRequired,
  ctxMenu: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
    node: PropTypes.node,
  }).isRequired,
  onCloseCtxMenu: PropTypes.func.isRequired,
  onDeleteItem: PropTypes.func.isRequired,
  onEditItem: PropTypes.func.isRequired,
  editDialog: PropTypes.shape({
    opened: PropTypes.bool,
    name: PropTypes.string,
  }).isRequired,
  onCloseEditDialog: PropTypes.func.isRequired,
  subItems: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    errored: PropTypes.bool,
    useHierarchy: PropTypes.bool,
    canHierarchy: PropTypes.bool,
  })).isRequired,
  onRemoveSubGroup: PropTypes.func.isRequired,
  onUpSubgroup: PropTypes.func.isRequired,
  onDownSubgroup: PropTypes.func.isRequired,
};

export default GroupEditor;
